/*
 * @Author: 冯杰
 * @Date: 2021-08-19 14:26:35
 * @LastEditTime: 2021-08-19 14:33:47
 * @FileName: 文件名
 */
import RedEnvelope from './redenvelope.vue';

export default RedEnvelope;
